import React from 'react';

import { useForm } from 'react-hook-form';

import { LbModal } from '../../../../shared/components/modals';
import { PhoneNumberInput } from '../../../../shared/components/form-components';
import { goTo } from '../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../constants/pathQueryParams';
import { twoFAService, VERIFICATION_CHANNEL } from '../../../../auth-management';

type FormValues = {
  phoneNumber: string;
};

type JoinToChallengeModalProps = {
  challengeId: string;
  open: boolean;
  onClose: () => void;
};

const JoinToChallengeModal = ({
  challengeId,
  open,
  onClose,
}: JoinToChallengeModalProps) => {
  const { control, handleSubmit } = useForm<FormValues>({
    shouldUnregister: true,
  });

  const handleFormSubmit = handleSubmit(async (data) => {
    // This extra request is needed to ensure that the phone number is valid before moving the user to the next step.
    // We send the same request on the next step to get the verification code expiration time, but it does not trigger a second SMS while the current code has not expired.
    await twoFAService.sendVerificationCode(data.phoneNumber, VERIFICATION_CHANNEL.SMS);

    goTo(`/challenge-sign-up/${challengeId}`, {
      params: {
        [pathQueryParams.phoneNumber]: data.phoneNumber,
      },
    });

    onClose();
  });

  return (
    <LbModal
      open={open}
      onClose={onClose}
      title="Join to Challenge!"
      text="Please enter your cell phone number. 
This should match your InBody ID."
      primaryBtnConfig={{
        text: 'Confirm',
        onClick: handleFormSubmit,
      }}
      secondaryBtnConfig={{
        text: 'Close',
        onClick: onClose,
      }}
    >
      <PhoneNumberInput
        control={control}
        variant="outlined"
        name="phoneNumber"
        label="Cell Phone"
        rules={{
          required: 'Cell Phone is required',
        }}
      />
    </LbModal>
  );
};

export { JoinToChallengeModal };
